import React, { useState, useEffect } from 'react'
import About1 from "../../../assets/images/about-1.jpg"
// import About2 from "../../../assets/images/about-2.jpg"
import Shape1 from "../../../assets/images/shape-11.png"
// import Signature from "../../../assets/images/signature-1.png"
import { Link } from 'react-router-dom'
import { axiosInstance, config } from '../config'
import Bredcrum from '../../common/Bredcrum'
import secureLocalStorage from 'react-secure-storage'
import team3 from "../../../assets/images/team/team-1.jpg"

const InstructorDetails = () => {

    const instructorData = secureLocalStorage.getItem("Instructor_Details");
    const [instructorDetail, setInstructorDetail] = useState(null)

    useEffect(() => {
        if (instructorData?.id) {
            axiosInstance.get(`getinstructor/${instructorData.id}`)
                .then(res => {
                    if (res.data.status === 'success') {
                        setInstructorDetail(res.data.instructor)
                    }
                })
                .catch(err => console.error(err))
        }
    }, [instructorData?.id])

    const timeSlots = (instructorDetail?.time_slots || []).map(ts => ({
        ...ts,
        parsedSlots: (() => { try { return JSON.parse(ts.slots) } catch { return [] } })()
    }))

    return (
        <>
            <Bredcrum
                heading={'Instructor Profile'}
                path={[
                    { name: 'Instructor Profile', path: 'instructor' },
                ]}
            />

            <section className="about-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-8 col-md-12 col-sm-12 big-column ">
                            <div className="inner-box">
                                <div className="title-text mb-2 mb-xl-5 mt-3 mt-xl-0">
                                    <h2>{instructorData?.name}</h2>
                                </div>
                                <div className="row clearfix">
                                    <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                                        <div className="image-box d-md-block d-none">
                                            <figure className="image">
                                                <img src={About1} alt="" />
                                            </figure>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                                        <div className="content-box">
                                            <h5 className='fw-semibold mb-4'>Instructor</h5>
                                            {/* <h3 className='display-6 mb-3 fw-semibold'>{instructorData?.name}</h3> */}
                                            <div className="text">
                                                <p>{instructorData?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12 small-column position-relative">
                            <div className="image-box">
                                <div className="shape" style={{ backgroundImage: `url(${Shape1})` }}></div>
                                <figure className="image"><img src={instructorData?.image ? instructorData?.imageUrl : team3 } alt="" /></figure>
                                {timeSlots.some(ts => ts.parsedSlots.length > 0) && <div className='my-4' style={{ border: '1px solid rgba(1,146,47,0.3)', borderRadius: '8px', maxHeight: '210px', overflowY: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                        <thead>
                                            <tr style={{ background: '#01922f', position: 'sticky', top: 0, zIndex: 1 }}>
                                                <th style={{ color: '#fff', padding: '8px 12px', fontWeight: 600, textAlign: 'left' }}>Day</th>
                                                <th style={{ color: '#fff', padding: '8px 12px', fontWeight: 600, textAlign: 'left' }}>Location</th>
                                                <th style={{ color: '#fff', padding: '8px 12px', fontWeight: 600, textAlign: 'left' }}>Lesson Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {timeSlots.map((ts) =>
                                                ts.parsedSlots.map((slot, i) => (
                                                    <tr key={`${ts.id}-${i}`} style={{ background: i % 2 === 0 ? 'rgba(1,146,47,0.05)' : '#fff', borderBottom: '1px solid rgba(1,146,47,0.15)' }}>
                                                        <td style={{ padding: '8px 12px', color: '#01922f', fontWeight: 600 }}>{ts.days}</td>
                                                        <td style={{ padding: '8px 12px', color: '#121113' }}>{slot.location || '—'}</td>
                                                        <td style={{ padding: '8px 12px', color: '#121113' }}>{slot.lesson_type || '—'}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>}
                                <div className="btn-box">
                                    <Link to={`${config.appUrl}book-a-lesson`}
                                        state={{ data: instructorData?.id }}
                                        className="theme-btn btn-two">
                                        Book Online Now</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InstructorDetails
